import type { Staged } from '~/core/router'

import { createEvent, createStore, sample } from 'effector'
import { model as router, stages } from '~/core/router'
import { T } from '~/shared/helpers'

export const init = createEvent<{
  query: URLSearchParams
  stage: Staged['stage']
}>()

const { reload } = stages(init)

const isReloading = createEvent<string>()
export const $isReloading = createStore(false) //
  .on(isReloading, T)
  .reset(init)

sample({
  clock: reload,
  filter: ({ query }) => Boolean(query.get('from')),
  fn: ({ query }) => query.get('from')!,
  target: isReloading,
})

sample({
  clock: isReloading,
  target: router.navigateReplace,
})
